import type { ReactElement } from 'react';

export function noLayout(page: ReactElement) {
  return page;
}
